import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';

const ModifyAddress = ({ className, onClick, t }) => (
  <div className={className}>
    <Button
      icon="edit"
      onClick={onClick}
      iconPosition="left"
      text={t('modify_address')}
      ghost
    />
  </div>
);

ModifyAddress.propTypes = {
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func,
};

ModifyAddress.defaultProps = {
  className: '',
  t: (t) => t,
};

export default ModifyAddress;
